module.exports = __webpack_public_path__ + "static/media/test5.a55d09f5.jpeg";